"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get_rounding_precision_1 = require("./get-rounding-precision");
var intl_format_1 = require("@biw/intl-format");
var getFormatStyle = function (labelType) {
    switch (labelType) {
        case 'percentage':
            return 'percent';
        case 'currency':
            return 'currency';
        default:
            return 'decimal';
    }
};
exports.getLabelString = function (label, amount, precision, roundingMethod, locale) {
    var _a = label ? label : {}, _b = _a.labelPosition, labelPosition = _b === void 0 ? undefined : _b, _c = _a.labelText, labelText = _c === void 0 ? undefined : _c, _d = _a.labelType, labelType = _d === void 0 ? undefined : _d, _e = _a.currencyCode, currencyCode = _e === void 0 ? undefined : _e;
    var displayAmount = get_rounding_precision_1.getRoundingPrecision(roundingMethod, amount, precision);
    var formatOptions = {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
        style: getFormatStyle(labelType),
        currency: undefined
    };
    if (labelType === 'currency') {
        var currency = currencyCode || 'USD';
        formatOptions.currency = currency.toUpperCase();
    }
    var displayAmountValue = intl_format_1.formatNumber(locale, formatOptions, displayAmount);
    if (!labelText) {
        return displayAmountValue;
    }
    return labelPosition === 'before' ?
        labelText + " " + displayAmountValue :
        displayAmountValue + " " + labelText;
};
//# sourceMappingURL=get-label-string.js.map